import LocalStorageData from './LocalStorageData';

export default LocalStorageData;
